import { Charge, Result } from "../models/interfaces";
import { BaseService } from "./BaseService";

export class ChargeService extends BaseService {
  private api = "charges";

  async getCharges(params: {
    id?: number;
    name?: string;
    pageIndex?: number;
    pageCount?: number;
  }): Promise<Result<Charge[]>> {
    const queryparams = this.ToQueryString(params);
    return this.get(`${this.api}${queryparams}`);
  }

  async getCharge(id: number): Promise<Result<Charge>> {
    return this.get(`${this.api}/${id}`);
  }

  async deleteCharge(id: number): Promise<Result<boolean>> {
    return this.delete(`${this.api}/${id}`);
  }

  async addOrCreateCharge(
    params: Charge,
    id?: number
  ): Promise<Result<Charge | boolean>> {
    if (id) {
      return this.put(`${this.api}/${id}`, params);
    } else {
      return this.post(`${this.api}`, params);
    }
  }
}

export default new ChargeService();
